/** @jsxImportSource @emotion/react */
import { Typography } from '@quickbit/qb-design-system';
import { diff, formatters } from 'jsondiffpatch';
import 'jsondiffpatch/dist/formatters-styles/html.css';
import { useMemo } from 'react';

interface Props {
  oldObject: any;
  newObject: any;
}

export const JsonDiff = ({ oldObject, newObject }: Props) => {
  const htmlDiff = useMemo(() => {
    const d = diff(oldObject, newObject);
    const formatter = formatters.html;
    formatter.hideUnchanged();
    if (d) return formatter.format(d, oldObject);
    return null;
  }, [oldObject, newObject]);

  if (!htmlDiff) return <Typography>No changes</Typography>;
  return <div dangerouslySetInnerHTML={{ __html: htmlDiff }} />;
};
